
import { Component, Mixins } from 'vue-property-decorator';
import moment from 'moment';
import { BoxOutcomeType } from '@/types';
import OperationComponentMixin from '@/mixins/OperationComponentMixin.vue';

moment.locale('it');

@Component
export default class OperationTestingDate extends Mixins(OperationComponentMixin) {
  get testingDate(): string | null {
    return this.operationChild
      && this.operationChild.testingDate
      && moment(this.operationChild.testingDate).isValid()
      ? moment(this.operationChild.testingDate).format('L')
      : null;
  }

  get testingNotes(): string | null {
    return this.operationChild?.testingNotes || null;
  }

  get testingDateConfirm(): boolean {
    return this.operationChild?.testingDateConfirm === true;
  }

  get testingOutcome(): BoxOutcomeType | null {
    return this.operation && 'testingOutcome' in this.operation ? this.operation.testingOutcome : null;
  }

  get tooltipText() {
    let text = '';

    if (this.operationChild?.flatTasks.includes('R=c')) {
      text += 'Collaudo completato';
    } else if (this.testingDate) {
      text += this.testingDateConfirm
        ? 'Data prevista per il collaudo (confermata)'
        : 'Data prevista per il collaudo (non confermata)';
    } else {
      text += 'Data prevista per il collaudo da definire';
    }

    if (this.testingNotes
      && this.isCurrentUserOwnerOrRequester
      && this.hasPermission('taski.testingNotes.show')
    ) text += `<br>${this.testingNotes}`;

    return text;
  }

  get columnClass(): string {
    if (this.operationChild?.flatTasks.includes('R=c')) return 'completed';
    if (this.operationChild?.flatTasks.includes('R=e')) return 'error';

    // if (this.testingOutcome === 'todo') return 'grey';
    if (this.testingOutcome === 'success') return 'completed';
    if (this.testingOutcome === 'fail') return 'error';
    if (this.testingOutcome === 'warning') return 'warning';

    if (this.testingDateConfirm) return 'selected';
    return '';
  }

  onEdit() {
    console.log('OperationInstallation: onEdit()'); // eslint-disable-line no-console
    this.$emit('edit');
  }
}
